import script from "./ListarAniversariantes.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarAniversariantes.vue?vue&type=script&setup=true&lang=js"

import "./ListarAniversariantes.vue?vue&type=style&index=0&id=2d787f46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d787f46"]])

export default __exports__